import { useAppSelector } from '@/app'
import { selectors as coreSelectors } from '@/features/core'
import { Stack } from '@mui/material'
import { useIsFetching } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { MdFavorite, MdOutlineFavoriteBorder } from 'react-icons/md'

export const GlobalLoadingIndicator = () => {
  const isFetching = useIsFetching({})
  const debug = useAppSelector(coreSelectors.selectDebug)
  const [lastTimeIndicatorWasZero, setLastTimeIndicatorWasZero] = useState(0)
  useEffect(() => {
    if (isFetching === 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLastTimeIndicatorWasZero(new Date().getTime())
    }
  }, [isFetching])
  const now = new Date().getTime()
  const isStale = now - lastTimeIndicatorWasZero > 1000 * 60
  const color = isStale ? 'gray' : 'white'
  const indicator =
    isFetching !== 0 ? (
      <>
        <MdOutlineFavoriteBorder
          style={{ color: color, padding: '0.1em', fontSize: '1.2em' }}
        />
        {debug && (
          <div style={{ minWidth: '1em', color: color }}>{isFetching}</div>
        )}
      </>
    ) : (
      <>
        <MdFavorite
          style={{ color: color, padding: '0.1em', fontSize: '1.2em' }}
        />
        {debug && <div style={{ minWidth: '1em' }}>&nbsp;</div>}
      </>
    )

  return debug ? (
    <div
      style={{
        marginLeft: 'auto',
        marginRight: 0,
        maxWidth: '3em',
      }}
    >
      <Stack direction="row">{indicator}</Stack>
    </div>
  ) : (
    <div
      onClick={() => {
        if (isStale) {
          window.location.reload()
        }
      }}
    >
      {indicator}
    </div>
  )
}
